module.exports = __webpack_public_path__ + "img/8.a1438e73.jpg";